import React from "react";
import "./style.css";
import moment from "moment";
import { END_HOUR_TIME, START_HOUR_TIME } from "../../constants";

const TimePickerComponent = ({
  therapistIndex = 0,
  dayIndex = 0,
  handleShiftChange = () => {},
  name = "",
  value = moment(`${START_HOUR_TIME}:00`, "HH:mm"),
  onChange = () => {},
}) => {
  const generateHourOptions = () => {
    const hours = [];
    for (let i = START_HOUR_TIME; i <= END_HOUR_TIME; i++) {
      hours.push(
        <option key={i} value={i % 24}>
          {(i % 24).toString().padStart(2, "0")}
        </option>
      );
    }
    return hours;
  };

  const generateMinuteOptions = () => {
    const minutes = [];
    for (let i = 0; i < 60; i += 30) {
      minutes.push(
        <option key={i} value={i}>
          {i.toString().padStart(2, "0")}
        </option>
      );
    }

    return minutes;
  };

  const handleChangeTime = (newValue, type) => {
    const hour = value.hour();
    const minute = value.minute();
    let time;
    if (type === "hour") {
      if (Number(value) === END_HOUR_TIME - 24) {
        time = moment(`${END_HOUR_TIME - 24}:00`, "HH:mm");
      } else time = moment(`${newValue}:${minute}`, "HH:mm");
    } else {
      time = moment(`${hour}:${newValue}`, "HH:mm");
    }
    handleShiftChange(therapistIndex, dayIndex, name, time);
    onChange(time);
  };

  return (
    <div className="select-time">
      <select
        className="select-time"
        value={value.hour()}
        onChange={(e) => handleChangeTime(e.target.value, "hour")}
      >
        {generateHourOptions()}
      </select>
      :
      <select
        className="select-time"
        value={value.minute()}
        onChange={(e) => handleChangeTime(e.target.value, "minute")}
      >
        {generateMinuteOptions()}
      </select>
    </div>
  );
};

export default TimePickerComponent;
